import Fase from 'models/enums/Fase';
import { Lotto } from 'models/results/lotto';
import { Pagination, PaginationResult } from 'types/pagination';
import axios from 'utils/axios';
import { Data, LottoFilters } from 'views/intervention-plans/lotti/lotti';

class LottoService {
    async getLottiPaginated(
        tenantId: string,
        pagination: Pagination,
        filters: LottoFilters<Data>,
        simulazioneId: string | null
    ): Promise<PaginationResult<Lotto>> {
        try {
            const result = await axios.post<PaginationResult<Lotto>>('/GetLottiPaginated', {
                ...pagination,
                ...filters,
                tenantId,
                simulazioneId
            });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch lotti');
        }
    }

    async getLotto(tenantId: string, id: string, simulazioneId: string | null): Promise<Lotto> {
        try {
            const res = await axios.post<Lotto>('/GetLottoById', { tenantId, id, simulazioneId });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to get lotto');
        }
    }

    async upsertLotto(tenantId: string, userId: string, username: string, lotto: Lotto, simulationId: string | null): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/UpsertLotto', {
                tenantId,
                userId,
                username,
                ...lotto,
                simulazioneId: simulationId,
                referentIds: lotto.users?.map((user) => user.userId) || []
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to upsert lotto');
        }
    }

    async ckeckLottoExist(tenantId: string, lotto: Lotto, simulationId: string | null): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/CkeckLottoExist', { tenantId, ...lotto, simulazioneId: simulationId });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Lotto already exist');
        }
    }

    async getLottoItems(
        tenantId: string,
        famigliaDiInterventoId: string | null,
        simulationId: string | null,
        dtTronchiToExclude?: string[]
    ): Promise<Lotto[]> {
        try {
            const res = await axios.post<Lotto[]>('/GetLottoItems', {
                tenantId,
                famigliaDiInterventoId,
                simulazioneId: simulationId,
                dtTronchiToExclude
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch lotti items');
        }
    }

    async changeListinoLotti(tenantId: string, userId: string, username: string, lottoIds: string[], listinoId: string): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/ChangeListinoLotti', { tenantId, userId, username, lottoIds, listinoId });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to change listino to lotti');
        }
    }
}

export default LottoService;
